module.exports = __webpack_public_path__ + "img/0.63aeb528.png";